import { compilePossessor, type PossessorCompileContext } from './possessor-compile';
import { fromBaseRecord, type FromBaseRow as Row } from './from-base-context';
import { applyStatusRootFields } from './status-root-residue';
import { retainHeld } from '../inventory/memory-pickup';
import { readItemUuidSlot } from './inventory-raw-readers';
import type { EquipPlanRow } from '../inventory/equip-plan';

const record = (value: unknown): Row => fromBaseRecord(value) ? value : {};

/** The local decision and its saved echo derive the same equipment dependencies.
 * Only the supplied dependency view receives output; the held member is borrowed. */
export function projectEquipmentDependencies(member: Row, view: Row, changes: readonly EquipPlanRow[], context: PossessorCompileContext,
    projection = record(view.computed)) {
    const primary = changes.find(change => readItemUuidSlot(change.equipped)) ?? changes[0];
    if (!primary) return { ok: false as const, reason: 'equipment-plan-empty' };
    const slot = readItemUuidSlot(primary.equipped);
    const result = compilePossessor(member, { kind: slot ? 'equip' : 'unequip', inventory_id: primary.inventory_id, equipped: slot,
        stow: changes.filter(change => change !== primary && !readItemUuidSlot(change.equipped)).map(change => change.inventory_id),
        reslot: changes.filter(change => change !== primary && readItemUuidSlot(change.equipped))
            .map(change => ({ inventory_id: change.inventory_id, equipped: readItemUuidSlot(change.equipped) })) }, context);
    if (!result.ok) return result;
    projection.creature = retainHeld(record(member.computed).creature, result.derived['computed.creature']);
    projection.vitality = retainHeld(record(member.computed).vitality, result.derived['computed.vitality']);
    view.catalog = result.derived.catalog;
    if (result.derived.root_buckets) view.item_layer_types = { ...record(member.item_layer_types), ...result.derived.root_buckets };
    for (const [key, value] of Object.entries(result.derived.root_scalars ?? {})) { if (value === null) delete view[key]; else view[key] = value; }
    applyStatusRootFields(view, result.derived.root_fields);
    return result;
}
